import seedrandom from 'seedrandom';
import { ILimit } from './MathHelper';

// Default random seed.
let rng = seedrandom();

export namespace Random {
    export interface IWeightedItem<T> {
        odds: number;
        data: T;
    }
    /**
     * Apply a seed for predictable numbers (only through the 'Random' namespace).
     * @param seed
     */
    export function seed(seed?: any) {
        rng = seedrandom(seed);
    }

    export function value(min: number = 0, max: number = 1): number {
        return rng() * (max - min) + min;
    }

    /** Rolling 0.75 (so 75%) should return true more often than false */
    export function roll(chance: number): boolean {
        return chance > value();
    }

    /** Inclusive of max value */
    export function int(min: number, max: number): number {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Random.value() * (max - min + 1)) + min;
    }

    /** Inclusive of max value */
    export function range(range: ILimit): number {
        return int(range?.min ?? 0, range?.max ?? 0);
    }

    export function sign() {
        return Random.int(0, 1) * 2 - 1;
    }

    export function ID(): string {
        return Random.value()
            .toString(36)
            .substr(2, 9);
    }

    // //TODO: Add getweighteditem
    // {
    //     odds: 15,
    //     data: {
    //         type: 'conis',
    //         value: 100,
    //     }
    // }

    export function getRandomWeighted<T>(items: IWeightedItem<T>[]): T {
        const weights: number[] = items.map(item => item.odds);
        const totalWeight = weights.reduce((p: number, v: number) => p + v, 0);
        const num = Random.value(0, totalWeight);

        let sum = 0;
        for (let i = 0; i < weights.length; i++) {
            sum += weights[i];

            if (num <= sum) {
                return items[i].data;
            }
        }
    }

    export function getRandomWeightedIndex<T>(items: IWeightedItem<T>[]): number {
        return Random.getRandomWeighted(items.map((w, i) => ({ data: i, odds: w.odds })));
    }

    export function getRandomItem<T>(array: T[]): T {
        if (array.length === 0) return undefined;
        return array[Random.int(0, array.length - 1)];
    }
}
